// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__p5Fnf","colBig":"styles_colBig__1lu_s","colSmall":"styles_colSmall__2jzqJ","shopifyNameWrapper":"styles_shopifyNameWrapper__2rp4D"};